import { commonImages } from '../images/common-images';
import { contactImages } from '../images/contact-images';
import { contractImages } from '../images/contract-images';
import { dashboardImages } from '../images/dashboard-images';
import { emailCalendarImages } from '../images/email-calendar-images';
import { leadImages } from '../images/lead-images';
import { libraryImages } from '../images/library-images';
import { marketPlaceImages } from '../images/market-place-images';
import { myInboxImages } from '../images/my-inbox-images';
import { projectImages } from '../images/project-images';
import { propertyImages } from '../images/property-images';
import { reportImages } from '../images/reports-images';
import { settingsImages } from '../images/settings-images';
import { sideMenuImages } from '../images/side-menu-images';
import { taskImages } from '../images/task-images';

//#region Calendar
const calendar0 = commonImages?.calendar_icon_v2;
const calendar2 = emailCalendarImages?.calendar_2_icon;
const calendar9 = emailCalendarImages?.calendar_9_images;
//#endregion Calendar

//#region Contact
const contact0 = commonImages?.phoneBook_icon;
const contact1 = contactImages?.contact_1_icon;
const contact2 = contactImages?.contact_2_icon;
const contact4 = contactImages?.contact_4_icon;
const contact6 = contactImages?.contact_6_icon;
const contact7 = contactImages?.contact_7_icon;
const contact9 = contactImages?.contact_9_icon;
const contact10 = contactImages?.contact_10_icon;
const contact11 = contactImages?.contact_11_icon;
const contact16 = contactImages?.contact_16_icon;
//#endregion Contact

//#region Contracts
const contract0 = commonImages?.contract_icon;
const contract1 = contractImages?.contract_1_icon;
const contract2 = contractImages?.contract_2_icon;
const contract3 = contractImages?.contract_3_icon;
const contract4 = contractImages?.contract_4_icon;
const contract5 = contractImages?.contract_5_icon;
const contract6 = contractImages?.contract_6_icon;
const contract7 = contractImages?.contract_7_icon;
const contract8 = contractImages?.contract_8_icon;
const contract9 = contractImages?.contract_9_icon;
//#endregion Contracts

//#region Dashboard
const dashboard0 = commonImages?.home_sidebar_icon;
//#endregion Dashboard

//#region Email
const email0 = dashboardImages?.email_icon;
const email1 = myInboxImages?.email_1_icon;
const email2 = myInboxImages?.email_2_icon;
const email3 = myInboxImages?.email_3_icon;
const email4 = myInboxImages?.email_4_icon;
const email5 = myInboxImages?.email_5_icon;
const email6 = myInboxImages?.email_6_icon;
const email7 = myInboxImages?.email_7_icon;
const email8 = myInboxImages?.email_8_icon;
const email9 = myInboxImages?.email_9_icon;
//#endregion Email

//#region History
const history0 = commonImages?.history_icon;
const history1 = sideMenuImages?.history_1_icon;
const history2 = sideMenuImages?.history_2_icon;
const history3 = sideMenuImages?.history_3_icon;
const history4 = sideMenuImages?.history_4_icon;
const history5 = sideMenuImages?.history_5_icon;
//#endregion History

//#region Lead
const lead0 = commonImages?.lead_icon;
const lead1 = leadImages?.lead_1_icon;
const lead2 = leadImages?.lead_2_icon;
const lead3 = leadImages?.lead_3_icon;
const lead4 = leadImages?.lead_4_icon;
const lead5 = leadImages?.lead_5_icon;
//#endregion Lead

//#region Library
const library0 = commonImages?.folder_icon;
const library1 = libraryImages?.library_1_icon;
const library2 = libraryImages?.library_2_icon;
const library3 = libraryImages?.library_3_icon;
const library4 = libraryImages?.library_4_icon;
const library5 = libraryImages?.library_5_icon;
const library6 = libraryImages?.library_6_icon;
const library7 = libraryImages?.library_7_icon;
//#endregion Library

//#region Listing
const listing0 = commonImages?.listing_icon;
const listing1 = propertyImages?.listing_1_icon;
const listing2 = propertyImages?.listing_2_icon;
const listing3 = propertyImages?.listing_3_icon;
const listing4 = propertyImages?.listing_4_icon;
const listing5 = propertyImages?.listing_5_icon;
const listing6 = propertyImages?.listing_6_icon;
const listing7 = propertyImages?.listing_7_icon;
const listing8 = propertyImages?.listing_8_icon;
const listing9 = propertyImages?.listing_9_icon;
//#endregion Listing

//#region MarketPlace
const market0 = commonImages?.marketplace_icon;
const market1 = marketPlaceImages?.market_1_icon;
const market2 = marketPlaceImages?.market_2_icon;
const market3 = marketPlaceImages?.market_3_icon;
const market4 = marketPlaceImages?.market_4_icon;
//#endregion MarketPlace

//#region Pin
const pin0 = commonImages?.pin_icon;
const pin1 = sideMenuImages?.pin_1_icon;
const pin2 = sideMenuImages?.pin_2_icon;
const pin3 = sideMenuImages?.pin_3_icon;
const pin4 = sideMenuImages?.pin_4_icon;
const pin5 = sideMenuImages?.pin_5_icon;
const pin6 = sideMenuImages?.pin_6_icon;
const pin7 = sideMenuImages?.pin_7_icon;
const pin8 = sideMenuImages?.pin_8_icon;
//#endregion Pin

//#region Projects
const projects0 = commonImages?.project_1;
const projects1 = projectImages?.project_1_icon;
const projects2 = projectImages?.project_2_icon;
const projects3 = projectImages?.project_3_icon;
const projects4 = projectImages?.project_4_icon;
const projects5 = projectImages?.project_5_icon;
const projects6 = projectImages?.project_6_icon;
const projects7 = projectImages?.project_7_icon;
const projects8 = projectImages?.project_8_icon;
const projects9 = projectImages?.project_9_icon;
//#endregion Projects

//#region Report
const report0 = commonImages?.report_icon;
const report1 = reportImages?.report_1_icon;
const report2 = reportImages?.report_2_icon;
const report3 = reportImages?.report_3_icon;
const report4 = reportImages?.report_4_icon;
const report5 = reportImages?.report_5_icon;
const report6 = reportImages?.report_6_icon;
const report7 = reportImages?.report_7_icon;
const report8 = reportImages?.report_8_icon;
const report9 = reportImages?.report_9_icon;
const report10 = reportImages?.report_10_icon;
const report11 = reportImages?.report_11_icon;
const report12 = reportImages?.report_12_icon;
//#endregion Report

//#region Settings
const settings0 = commonImages?.settings_icon;
const settings1 = settingsImages?.setting_1_icon;
const settings2 = settingsImages?.setting_2_icon;
const settings3 = settingsImages?.setting_3_icon;
const settings4 = settingsImages?.setting_4_icon;
const settings5 = settingsImages?.setting_5_icon;
//#endregion Settings

//#region Tasks
const tasks0 = commonImages?.task_icon;
const tasks1 = taskImages?.task_1_icon;
const tasks2 = taskImages?.task_2_icon;
const tasks3 = taskImages?.task_3_icon;
const tasks4 = taskImages?.task_4_icon;
const tasks5 = taskImages?.task_5_icon;
const tasks6 = taskImages?.task_6_icon;
const tasks7 = taskImages?.task_7_icon;
//#endregion Tasks

const dotss = commonImages?.dots_icon;

export const misc = {
  dotss,
};
export const calendar = {
  calendar0,
  calendar2,
  calendar9,
};

export const contacts = {
  contact0,
  contact1,
  contact2,
  contact4,
  contact6,
  contact7,
  contact9,
  contact10,
  contact11,
  contact16,
};

export const contracts = {
  contract0,
  contract1,
  contract2,
  contract3,
  contract4,
  contract5,
  contract6,
  contract7,
  contract8,
  contract9,
};

export const dashboard = {
  dashboard0,
};

export const emails = {
  email0,
  email1,
  email2,
  email3,
  email4,
  email5,
  email6,
  email7,
  email8,
  email9,
};

export const history = {
  history0,
  history1,
  history2,
  history3,
  history4,
  history5,
};

export const leads = {
  lead0,
  lead1,
  lead2,
  lead3,
  lead4,
  lead5,
};

export const library = {
  library0,
  library1,
  library2,
  library3,
  library4,
  library5,
  library6,
  library7,
};

export const listings = {
  listing0,
  listing1,
  listing2,
  listing3,
  listing4,
  listing5,
  listing6,
  listing7,
  listing8,
  listing9,
};

export const market = {
  market0,
  market1,
  market2,
  market3,
  market4,
};

export const pins = {
  pin0,
  pin1,
  pin2,
  pin3,
  pin4,
  pin5,
  pin6,
  pin7,
  pin8,
};

export const projects = {
  projects0,
  projects1,
  projects2,
  projects3,
  projects4,
  projects5,
  projects6,
  projects7,
  projects8,
  projects9,
};

export const reports = {
  report0,
  report1,
  report2,
  report3,
  report4,
  report5,
  report6,
  report7,
  report8,
  report9,
  report10,
  report11,
  report12,
};

export const settings = {
  settings0,
  settings1,
  settings2,
  settings3,
  settings4,
  settings5,
};

export const tasks = {
  tasks0,
  tasks1,
  tasks2,
  tasks3,
  tasks4,
  tasks5,
  tasks6,
  tasks7,
};

export const MenuIcons = {
  calendar,
  contacts,
  contracts,
  dashboard,
  emails,
  history,
  leads,
  library,
  listings,
  market,
  pins,
  projects,
  reports,
  settings,
  tasks,
  misc,
};
